import UrlPattern from 'url-pattern';
import qs from 'qs';

export const getRouteUrl = (route, params, queryParams) => {
  const path = new UrlPattern(route.route).stringify(params);
  const queries = qs.stringify(queryParams, { encode: false, arrayFormat: 'repeat' });
  return `${route.base}${path}${queries !== '' ? `?${queries}` : ''}`;
};
